import { CopyClipboard, IconButton, Text, Tooltip } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { ConfirmSmall, DuplicateSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { ContrastRatioLevel } from '../../types';
export const ColorSliderCopyIcon = _ref => {
  let {
    index,
    status,
    ctaName,
    colorState,
    currentContrastRatioLevel
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    hasChanged,
    hex
  } = colorState;
  return /*#__PURE__*/React.createElement(CopyClipboard, {
    resetTimeout: 1500,
    value: hex
  }, _ref2 => {
    let {
      isCopied,
      copyToClipboard,
      reset
    } = _ref2;
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement(Trans, {
        components: {
          confirmIcon: /*#__PURE__*/React.createElement(ConfirmSmall, {
            style: {
              verticalAlign: 'middle'
            }
          }),
          copiedTextColor: /*#__PURE__*/React.createElement(Text, {
            size: "tiny",
            skin: "success"
          }),
          copyText: /*#__PURE__*/React.createElement(Text, {
            size: "tiny"
          })
        },
        i18nKey: isCopied ? 'accessibility-wizard.rules-list.color-contrast.color-slider.copied' : 'accessibility-wizard.rules-list.color-contrast.color-slider.copy'
      }),
      size: "small"
    }, /*#__PURE__*/React.createElement(IconButton, {
      ariaLabel: `${t(`accessibility-wizard.rules-list.color-contrast.color-slider.copy.aria-label`)} ${hex}`,
      priority: "primary",
      size: "tiny",
      skin: (currentContrastRatioLevel === ContrastRatioLevel.AA || currentContrastRatioLevel === ContrastRatioLevel.AAA) && hasChanged ? 'standard' : 'light',
      onClick: () => {
        biLogger.taskElementCtaClick({
          ctaName,
          index,
          status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
        });
        copyToClipboard();
        reset();
      }
    }, isCopied ? /*#__PURE__*/React.createElement(ConfirmSmall, null) : /*#__PURE__*/React.createElement(DuplicateSmall, null)));
  });
};
//# sourceMappingURL=color-slider-copy-icon.js.map